import { API, API_TEMP } from "../instances"

// FOC-477 — Las llamadas del flujo de cambio aceptan dos modos:
//   - tempToken en sessionStorage (flujo tras login expirado) -> API_TEMP
//   - sesión normal (cambio desde el perfil)                  -> API
const hasTempToken = () => typeof window !== "undefined" && !!sessionStorage.getItem("tempToken")

const client = () => (hasTempToken() ? API_TEMP() : API())

export const requestChangeCode = async () => {
  const response = await client().post("user/password/change/requestCode", {})

  return response.data
}

export const verifyChangeCode = async (code) => {
  const response = await client().post("user/password/change/verifyCode", { code })

  return response.data
}

export const changePassword = async (data) => {
  const response = await client().post("user/password/change", data)

  return response.data
}


// FOC-477 / FOC-491 / FOC-492 — Devolvemos siempre el response (sea 200
// o un error 4xx) para que useLogin pueda inspeccionar el code del body
// (PASSWORD_EXPIRED, DEVICE_VERIFICATION_REQUIRED, ACCOUNT_BLOCKED,
// DEVICE_VERIFICATION_UNAVAILABLE, OTP_INVALID, etc.).
export const auth = async (payload) => {
  try {
    return await API().post("user/authentication", payload)
  } catch (error) {
    return error.response ?? { status: 0, data: {} }
  }
}

export const forgot = async (data) => {
  const response = await API().post("user/password/forgot", data)

  return response.data.data
}

export const verifyCode = async (data) => {
  const response = await API().post("user/password/verifyCode", data)

  return response.data
}

export const restore = async (data) => {
  const response = await API().post("user/password/restore", data)

  return response.data
}
